define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/Deferred",
	"dijit/registry",
	"dijit/Tree",
	"csi/widget/_CheckboxTreeNode"
], function(declare,lang,Deferred,registry,Tree,_CheckboxTreeNode) {

	// FIX - look into replacing with dojo foundation package cbtree found at https://github.com/pjekel/cbtree
	
	return declare(Tree, {
		// dojo.data.Item attributes used by widget
		CHECKBOX: "checkbox",
		ICON_CLASS: "iconClass",
		LABEL_CLASS: "labelClass",
		VALUE: "value",

		// String: disable DnD for tree - does not work (nor should it)
		dndController: "",

		// Boolean: Disables use of cookies for state saving.
		persist: false,

		// Boolean: indicates
		bExpandOnOpen: false,

		// Boolean: indicates if startup has been called or not
		_bStarted: false,

		// Boolean: indicates if tree uses write store
		_bWriteStore: false,


		getIconClass: function(/*dojo.data.Item*/item, /*Boolean*/opened) {
			// summary: return icon class for item - watch out for fake root item
			if (this.model.store.isItem(item)) {
				return this.model.store.getValue(item, this.ICON_CLASS);
			}

			return null;
		},

		getLabelClass: function(/*dojo.data.Item*/item, /*Boolean*/opened) {
			// summary: return label class for item - watch out for fake root item
			if (this.model.store.isItem(item)) {
				return this.model.store.getValue(item, this.LABEL_CLASS);
			}

			return null;
		},

		startup: function() {
			// summary: track when tree is started
			this.inherited(arguments);
			this._bStarted = true;

			// connect to onSet method if tree uses write store
			if (this.model.store.getFeatures()["dojo.data.api.Write"]) {
				this._bWriteStore = true;
				this.connect(this.model.store, "onSet", "_onSetChecked");
			}
		},

		onClick: function(/* dojo.data */ item, /*TreeNode*/ node, /*Event*/ evt){
			// summary: toggle checkbox if tree node clicked outside of checkbox
			var	cb = node.checkbox;
			if (cb && !cb.get("disabled")) {
				cb.set("value", !cb.get("value"));
			}
		},

		onTreeChecked: function(/*csi.widget.CheckboxTree*/tree) {
			// summary: extension point
		},

		onTreeExpanded: function(/*csi.widget.CheckboxTree*/tree) {
			// summary: extension point
		},

		_createTreeNode: function(/*Object*/args) {
			return new _CheckboxTreeNode(args);
		},

		_expandNode: function(/*_TreeNode*/ node, /*Boolean?*/ recursive){
			// summary: trap expanding tree on load if not desired
			var	dfd;

			if (this._bStarted || this.bExpandOnOpen || (!this.showRoot && (node == this.rootNode))) {
				dfd = this.inherited(arguments);
				dfd.then(lang.hitch(this, this.onTreeExpanded, this));
			} else {
				// skip expanding
				dfd = new Deferred();
				dfd.resolve(true);
			}

			return dfd;
		},

		_onClick: function(/*TreeNode*/ nodeWidget, /*Event*/ e){
			// summary: DOJO INTERNAL - overwrite base so that checkboxes toggle when clicked;
			// also toggle checkbox if label selected rather than checkbox
			var	w = registry.getEnclosingWidget(e.target);
			if (w && (w == nodeWidget.checkbox)) {
				// don't call onClick!
				this._publish("execute", { item: nodeWidget.item, node: nodeWidget, evt: e } );
				this.focusNode(nodeWidget);
				e.stopPropagation();
			} else {
				this.inherited(arguments);
			}
		},

		_onEnterKey: function(/*Object*/ message){
			// summary: DOJO INTERNAL - overwrite base so that it will work without DnD
			this._publish("execute", { item: message.item, node: message.node } );
			//this.dndController.userSelect(message.node, dojo.isCopyKey( message.evt ), message.evt.shiftKey);
			this.onClick(message.item, message.node, message.evt);
		},

		_onSetChecked: function(/*dojo.data.Item*/item, /*String*/attribute, /*Any*/oldValue, /*Any*/newValue) {
			// summary: refresh tree node checkbox with new value
			if (attribute == this.VALUE) {
				var	tn = this.getNodesByItem(item)[0];
				if (tn && (tn.getCheckboxValue() != newValue)) {
					tn.checkbox.set("value", newValue);
				}
			}
		},

		_setSelectedNodesAttr: function(nodes){
			// summary: DOJO INTERNAL - overwrite base so that it will work without DnD
		}
	});
});